import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';

import { useAPI } from 'hooks/api/useAPI';
import { updateQueriesData } from 'services/update_queries_data';

type UseDeleteCamerasParams = {
  camera_ids: string[];
};

export function useDeleteCameras({
  onMutate,
  onError,
  onSettled,
  ...options
}: UseMutationOptions<void, APIError, UseDeleteCamerasParams> = {}) {
  const queryClient = useQueryClient();
  const { applicationID, client } = useAPI();

  return useMutation(
    async ({ camera_ids }) => {
      await Promise.all(
        camera_ids.map((id) =>
          client.delete(`/apps/${applicationID}/cameras/${id}`)
        )
      );
    },
    {
      ...options,
      onMutate: async (params) => {
        onMutate?.(params);

        return updateQueriesData({
          queryClient,
          listQueryKey: ['cameras'],
          singleQueryKey: ['camera'],
          ids: params.camera_ids,
          updateData: null,
        });
      },
      onError: (error, params, context) => {
        onError?.(error, params, context);

        context?.previousLists?.forEach(([queryKey, data]) =>
          queryClient.setQueryData(queryKey, data)
        );
        context?.previousSingles?.forEach(([queryKey, data]) =>
          queryClient.setQueryData(queryKey, data)
        );
      },
      onSettled: (...args) => {
        onSettled?.(...args);

        queryClient.invalidateQueries(['cameras']);
        queryClient.invalidateQueries(['camera']);
      },
    }
  );
}
